import React from 'react'

type BoxOpenOrderTabIconProps = {
  testId?: string
}

export function BoxOpenOrderTabIcon({ testId }: BoxOpenOrderTabIconProps) {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      data-testid={testId}
    >
      <path
        d="M0.742188 7.10736L9.57063 10.7129L12.0189 7.30767L14.4448 10.7129L23.2584 6.80319L20.8621 3.59082L12.0189 7.30767L3.00494 3.94693L0.742188 7.10736Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M2.83984 8.32407V13.6211L12.0021 17.197L20.927 13.8734V8.08667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12.0039 7.74536V17.197"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M3.00391 3.94689L12.003 0.741943L20.8611 3.59078"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  )
}
